import React from 'react';

const Error404 = () => {
    return (
        <div>
            404 !
        </div>
    );
};

export default Error404;
